import apiFetch from '@wordpress/api-fetch';

/**
 * Returns an instance of apiFetch that is configured with the
 * root URL middleware using the configuration value passed in
 * from wp_localize_script.
 *
 * @returns {function} - A function to use as one would normally use apiFetch.
 */
export default function getApiFetch() {
  const {
    knightConfig: {
      restBase = '',
    } = {},
  } = window;

  // Attempt to extract the REST base from the config.
  if ('' === restBase) {
    return () => null;
  }

  // Initialize apiFetch and return it.
  apiFetch.use(apiFetch.createRootURLMiddleware(restBase));

  return apiFetch;
}
